/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentConnectionBlockIDForm,
  AgentConnectionBlockIDForm$Outbound,
  AgentConnectionBlockIDForm$outboundSchema,
} from "../components/agentconnectionblockidform.js";

export type RemoveAgentConnectionBlockSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RemoveAgentConnectionBlockRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  agentConnectionBlockIDForm: AgentConnectionBlockIDForm;
};

/** @internal */
export type RemoveAgentConnectionBlockSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RemoveAgentConnectionBlockSecurity$outboundSchema: z.ZodMiniType<
  RemoveAgentConnectionBlockSecurity$Outbound,
  RemoveAgentConnectionBlockSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function removeAgentConnectionBlockSecurityToJSON(
  removeAgentConnectionBlockSecurity: RemoveAgentConnectionBlockSecurity,
): string {
  return JSON.stringify(
    RemoveAgentConnectionBlockSecurity$outboundSchema.parse(
      removeAgentConnectionBlockSecurity,
    ),
  );
}

/** @internal */
export type RemoveAgentConnectionBlockRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AgentConnectionBlockIDForm: AgentConnectionBlockIDForm$Outbound;
};

/** @internal */
export const RemoveAgentConnectionBlockRequest$outboundSchema: z.ZodMiniType<
  RemoveAgentConnectionBlockRequest$Outbound,
  RemoveAgentConnectionBlockRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    agentConnectionBlockIDForm: AgentConnectionBlockIDForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      agentConnectionBlockIDForm: "AgentConnectionBlockIDForm",
    });
  }),
);

export function removeAgentConnectionBlockRequestToJSON(
  removeAgentConnectionBlockRequest: RemoveAgentConnectionBlockRequest,
): string {
  return JSON.stringify(
    RemoveAgentConnectionBlockRequest$outboundSchema.parse(
      removeAgentConnectionBlockRequest,
    ),
  );
}
